import { subjectDetailsActionTypes } from './Constants';
import * as subjectDetailsActions from './Actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		takeLatest(subjectDetailsActionTypes.GET_SUBJECT_DETAILS, handleSubjectDetailsRequest),
		takeLatest(subjectDetailsActionTypes.GET_SUBJECT_TOPICS, handleSubjectTopicsRequest),
		takeLatest(subjectDetailsActionTypes.GET_SUBJECT_EXAMS, handleSubjectExamsRequest),
	]);
}

export function* handleSubjectDetailsRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { subjectId } = data || {};

		const { data: respData } = yield call(processRequest, `public/subjects/${subjectId}`);

		yield put(subjectDetailsActions.getSubjectDetailsSuccess(respData.subject));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(subjectDetailsActions.getSubjectDetailsError());
	}
}

export function* handleSubjectTopicsRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { subjectId, queries } = data || {};

		const { data: respData } = yield call(
			processRequest,
			`public/subjects/${subjectId}/topics`,
			'GET',
			queries,
		);
		yield put(subjectDetailsActions.getSubjectTopicsSuccess(respData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(subjectDetailsActions.getSubjectTopicsError());
	}
}

export function* handleSubjectExamsRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { subjectId, queries, callback } = data || {};

		const { data: respData } = yield call(
			processRequest,
			`public/subjects/${subjectId}/exams`,
			'GET',
			queries,
		);

		if (callback) callback();

		yield put(subjectDetailsActions.getSubjectExamsSuccess(respData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(subjectDetailsActions.getSubjectExamsError());
	}
}
